import { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'

const BALL_GEO = new THREE.SphereGeometry(0.3, 6, 6)
const BALL_MAT = new THREE.MeshBasicMaterial({ color: '#2a2a2a' })

interface CannonballProps {
  position: THREE.Vector3
}

export function Cannonball({ position }: CannonballProps) {
  const meshRef = useRef<THREE.Mesh>(null)

  useFrame(() => {
    if (meshRef.current) {
      meshRef.current.position.copy(position)
    }
  })

  return <mesh ref={meshRef} geometry={BALL_GEO} material={BALL_MAT} />
}
